import { OnboardingApiClient } from "@/natsstubs/onboarding/client";

import type { NatsRpcBackend } from "../NatsRpcBackend";
import type { UnknownRecord } from "../RpcBackend";

export function registerOnboardingAdapters(nats: NatsRpcBackend): void {
  const client = new OnboardingApiClient(nats.caller);

  nats.register("onboarding", "core", {
    list_presets: async () => client.listPresets(),

    create_session: async (_args: unknown[], kwargs?: UnknownRecord) => {
      const res = await client.createSession({
        sessionName: String(kwargs?.session_name),
        artName: kwargs?.art_name as string,
        teams: kwargs?.team_names as [string, string, string, ...string[]],
        iterations: kwargs?.iteration_names as [string, string, string, ...string[]],
        presetId: String(kwargs?.preset_id),
      });
      return { session_id: res.sessionId, art_id: res.artId, team_ids: res.teamIds };
    },
  });
}
